import React, { useEffect } from 'react';
import ConsentPageContent from '../../components/consent/ConsentPageContent';
import { EDataSources } from '../../constants/EDataSources';
import Loader from '../../components/loader/Loader';
import { useAppState, useSelectedBank, useSelectedProvider, useStepsState } from '../../hooks/zustandHooks';
import { useConsentConfiguration } from '../../hooks/queryHooks';
import { useConsentConnectionMutation, useReauthenticateConsentConnectionMutation } from '../../hooks/mutationHooks';
import ConsentStatus from '../../domain/enums/ConsentStatus';
import { useTranslation } from 'react-i18next';
import { trackEvent } from '../../App';
import { EventTypes } from '../../utils/applicationInsights';

const ConsentPage = () => {
  const { consentConfiguration } = useConsentConfiguration();
  const { t } = useTranslation();
  const { mutateAsync: createConsentMutation, data: createConsentData } = useConsentConnectionMutation();
  const { mutateAsync: reauthenticateConsentMutation, data: reAuthData } = useReauthenticateConsentConnectionMutation();
  const setActiveStep = useStepsState(state => state.setActiveStep);

  const { redirectUrl } = useAppState(state => state.appState);
  const dataSource = useSelectedProvider(state => state.selectedProvider?.dataSource);
  const selectedBank = useSelectedBank(state => state.selectedBank);

  const isFastLink4Provider = dataSource === EDataSources.FL4;

  const isReauth = [ConsentStatus.Active, ConsentStatus.Expired, ConsentStatus.Revoked].includes(
    consentConfiguration?.consentStatus!
  );
  const data = isReauth ? reAuthData : createConsentData;
  const isLoading = !data || !redirectUrl || isFastLink4Provider;

  useEffect(() => {
    trackEvent({ type: EventTypes.CONSENT_ACCEPTED });
    setActiveStep({ stepIndex: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const runMutations = async () => {
      if (isReauth) await reauthenticateConsentMutation();
      else await createConsentMutation();
    };

    if (consentConfiguration) runMutations();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(consentConfiguration || {}).length, isReauth]);

  useEffect(() => {
    if (isFastLink4Provider) {
      trackEvent({ type: EventTypes.CREATE_CONSENT_SUCCESS });
      if(redirectUrl) window.location.replace(redirectUrl);
    }
  }, [redirectUrl, isFastLink4Provider]);

  if (isLoading) {
    return (
      <Loader
        showBackButton
        display={true}
        spinnerText={t('Loading...')}
        {...(isFastLink4Provider
          ? {
              showRecaptchaDisclaimer: false
            }
          : {
              logoUrl: selectedBank?.logoUrl,
              logoText: selectedBank?.name,
              framedLogo: true
            })}
      />
    );
  }

  return (
    <>
      {!isFastLink4Provider && (
        <ConsentPageContent
          consentConfiguration={consentConfiguration}
          isReauth={isReauth}
          bankName={selectedBank?.name || ''}
          bankLogoUrl={selectedBank?.logoUrl}
        />
      )}
    </>
  );
};

export { ConsentPage };
export default ConsentPage;
